import { render } from "./CantFind.vue?vue&type=template&id=12cb3d69"
import script from "./CantFind.vue?vue&type=script&lang=js"
export * from "./CantFind.vue?vue&type=script&lang=js"

import "./CantFind.vue?vue&type=style&index=0&id=12cb3d69&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__